import React, { useEffect, Fragment, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { show, hide } from "redux-modal";
import { ButtonClose, Icon } from "./style";
import { ShowAlertDialog } from "@de-prado-dev/react-component-library";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
//import SignatureCanvas from "react-signature-canvas";
import * as AttendanceService from "../../../../services/AttendanceService";
import { useNavigate } from "react-router-dom";
import PATHS from "../../../../constants/paths";
import {
  FormContainer,
  Header,
  HeaderTitle,
  HeaderSubtitle,
  FormBody,
  ButtonsContainer,
  CancelButton,
  ActionButton,
} from "./style";
import FormViewer from "./../../viewer/viewerForm/viewerForm.container";

const SignatureCanvas = require("react-signature-canvas").default;

const queryClient = new QueryClient();

export const useAttendance = (refresh) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();
  let alt = "";

  useEffect(() => {
    // StopServices.getLastStop().then((result) => {
    //   setLastStop(result);
    // });
  }, []);

  const signatureRef = useRef({});

  const [imageData, setImageData] = useState("");

  const handlerClosePopup = (popupName) => {
    dispatch(hide(popupName));
  };

  const saveSignature = (signature) => {
    setImageData(signature);
    alt = signature;
  };

  useEffect(() => {
    //console.log(imageData);
  }, [imageData]);

  const handlerOnSubmit = async (uuid) => {
    try {
      if (signatureRef !== null) {
        const signatureData = { signature: alt };
        const result = await AttendanceService.updateAttendance(
          signatureData,
          uuid
        );
        let title = "";
        let text = "";
        let icon = "";
        if (result) {
          title = t("forms.attendance.messages.title");
          text = t("forms.attendance.messages.create.success");
          icon = "success";
        } else {
          title = "Error";
          text = t("forms.attendance.messages.update.error");
          icon = "error";
        }

        let okAction = () => {
          handlerClosePopup("ModalForm");

        };

        if (result && refresh) {
          refresh();
        }

        ShowAlertDialog(title, text, icon, false, "OK", false, okAction);
      }
    } catch (error) {}
  };

  const signAttendance = async (dataRequest) => {
    // Determinar el ancho del canvas según el dispositivo
    const width = window.innerWidth;
    let canvasWidth = 780;
    let canvasHeight = 300;

    if (width <= 480) {
      canvasWidth = Math.min(width - 40, 300);
      canvasHeight = 150;
    } else if (width <= 768) {
      canvasWidth = Math.min(width - 50, 500);
      canvasHeight = 200;
    }

    dispatch(
      show("ModalForm", {
        body: (
          <>
            <div className="row mb-12">
              <div className="col-12 text-end">
                <ButtonClose
                  type="button"
                  onClick={() => handlerClosePopup("ModalForm")}
                >
                  <i className="fa-solid fa-xmark"></i>
                </ButtonClose>
              </div>
            </div>
            <FormContainer>
              <Header>
                <HeaderTitle>
                  {t("forms.attendance.signAttendance")}
                </HeaderTitle>
                <HeaderSubtitle>
                  {/* {t("forms.attendance.signAttendance")} */}
                </HeaderSubtitle>
              </Header>
              <FormBody>
                <QueryClientProvider client={queryClient}>
                  <div
                    className="row justify-content-center mb-3"
                    style={{ maxWidth: "100%", overflow: "auto" }}
                  >
                    <SignatureCanvas
                      canvasProps={{
                        width: canvasWidth,
                        height: canvasHeight,
                        style: {
                          border: "1px solid #203b34",
                          maxWidth: "100%",
                          height: "auto",
                        },
                      }}
                      ref={signatureRef}
                      onEnd={() =>
                        saveSignature(
                          signatureRef.current
                            .getCanvas()
                            .toDataURL("image/jpg")
                        )
                      }
                    />
                  </div>
                </QueryClientProvider>
              </FormBody>
              <ButtonsContainer>
                <CancelButton
                  type="button"
                  onClick={() => handlerClosePopup("ModalForm")}
                >
                  {t("forms.form.buttons.cancel")}
                </CancelButton>
                <ActionButton
                  type="button"
                  onClick={() => handlerOnSubmit(dataRequest)}
                >
                  {t("forms.form.buttons.save")}
                </ActionButton>
                <CancelButton
                  type="button"
                  onClick={() => {
                    signatureRef.current.clear();
                    saveSignature(null);
                  }}
                >
                  {t("forms.form.buttons.delete")}
                </CancelButton>
              </ButtonsContainer>
            </FormContainer>
            {/* <FormContainer>
              <div className="col-12">
                <div className="row justify-content-center mb-3">
                  <div className="col-12">
                    <h3 className="title">
                      {t("forms.attendance.signAttendance")}
                    </h3>
                  </div>
                </div>
                <div className="row justify-content-center mb-3">
                  <div className="col-12">
                    <QueryClientProvider client={queryClient}>
                      <div className="row justify-content-center mb-3">
                        <SignatureCanvas
                          canvasProps={{
                            width: 780,
                            height: 300,
                            style: { border: "1px solid #203b34" },
                          }}
                          ref={signatureRef}
                          onEnd={() =>
                            saveSignature(
                              signatureRef.current
                                .getCanvas()
                                .toDataURL("image/jpg")
                            )
                          }
                        />
                      </div>
                    </QueryClientProvider>

                    <div className="row justify-content-center">
                      <div className="col-10 col-sm-11 text-center mt-5 mb-5">
                        <button
                          type="button"
                          onClick={() => handlerClosePopup("ModalForm")}
                          className="btn btn-lg btn-secondary me-2"
                        >
                          {t("forms.form.buttons.cancel")}
                        </button>
                        <button
                          type="button"
                          onClick={() => handlerOnSubmit(dataRequest)}
                          className="btn btn-lg btn-primary me-2"
                        >
                          {t("forms.form.buttons.save")}
                        </button>
                        <button
                          className="btn btn-lg btn-secondary me-2"
                          onClick={() => {
                            signatureRef.current.clear();
                            saveSignature(null);
                          }}
                        >
                          {t("forms.form.buttons.delete")}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </FormContainer> */}
          </>
        ),
      })
    );
  };

  const createViewer = async (sessionUuid) => {
    dispatch(
      show("ModalForm", {
        body: (
          <>
            <FormContainer>
              <FormViewer sessionUuid={sessionUuid} refresh={refresh} />
            </FormContainer>
          </>
        ),
      })
    );
  };

  return {
    signAttendance,
    createViewer,
  };
};
